import { render, staticRenderFns } from "./card-send.vue?vue&type=template&id=3dc4e40e&scoped=true&"
import script from "./card-send.vue?vue&type=script&lang=js&"
export * from "./card-send.vue?vue&type=script&lang=js&"
import style0 from "./card-send.vue?vue&type=style&index=0&id=3dc4e40e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc4e40e",
  null
  
)

export default component.exports